import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useFetch } from '@reveni-io/reveni-ui'

import useLocations from '@/common/hooks/useLocations/useLocations'
import usePopulatedCarrierServices from '@/parcels/hooks/usePopulatedCarrierServices/usePopulatedCarrierServices'
import parcelServices from '@/parcels/services/services'
import routes from '@/Router/routes.constants'

import { canSplitSelection } from './helpers'
import { transformRequestSplitParcel } from './transformers'

const useParcelSplit = ({ parcel, storeId, setToastInfo }) => {
  const navigation = useNavigate()
  const [selectedItemsIds, setSelectedItemsIds] = useState([])
  const { locations } = useLocations({ storeId })
  const { carrierServices, fetchingCarriers } = usePopulatedCarrierServices({
    storeId,
    parcelCarrier: parcel?.related?.shipping_method?.carrier,
  })

  const { fetchData: splitParcelRequest, loading: splittingParcel } = useFetch(parcelServices.splitParcel, {
    doInitialRequest: false,
  })

  const [carrierServiceForNewShipment, setCarrierServiceForNewShipment] = useState('')
  const [locationForNewShipment, setLocationForNewShipment] = useState('')

  useEffect(() => {
    if (parcel?.related?.sender_location?.id) {
      setLocationForNewShipment(parcel.related.sender_location.id)
    }
    if (parcel?.related?.shipping_method?.carrier) {
      setCarrierServiceForNewShipment(parcel.related.shipping_method.carrier.id)
    }
  }, [parcel])

  const onToggleItem = itemId => {
    setSelectedItemsIds(prev => (prev.includes(itemId) ? prev.filter(id => id !== itemId) : [...prev, itemId]))
  }

  const isSplitParcelEnable = canSplitSelection(selectedItemsIds, parcel?.related?.line_items)

  const onSplitParcel = async () => {
    try {
      await splitParcelRequest({
        storeId,
        relatedId: parcel?.related?.id,
        payload: transformRequestSplitParcel({
          selectedItemsIds,
          locationForNewShipment,
          carrierServiceForNewShipment,
        }),
      })
      navigation(routes.parcelDetailPage.replace(':id', parcel.id))
    } catch (error) {
      setToastInfo({ show: true, message: error?.errorMessage, type: 'error' })
    }
  }

  return {
    parcel,
    locations,
    carrierServices,
    fetchingCarriers,
    selectedItemsIds,
    onToggleItem,
    carrierServiceForNewShipment,
    setCarrierServiceForNewShipment,
    locationForNewShipment,
    setLocationForNewShipment,
    splittingParcel,
    isSplitParcelEnable,
    onSplitParcel,
  }
}

export default useParcelSplit
